import Resizer from 'react-image-file-resizer';

async function imageResizer({
  file,
  maxWidth,
  maxHeight,
  format = 'jpeg',
  quality = 100,
  rotation = 0,
  output = 'base64',
  minWidth,
  minHeight,
  height,
  width
}) {
  return new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      maxWidth || width,
      maxHeight || height,
      format,
      quality || 100,
      0,
      (uri) => {
        resolve(uri);
      },
      output,
      minWidth || width,
      minHeight || height
    );
  });
}

export default imageResizer;
